"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _util = require("./util");
var _numeric = require("../format/numeric");
const isDefined = v => v !== undefined && v !== null;
class DateTimeless extends Date {
  constructor(val) {
    if (isDefined(val)) {
      super((0, _util.parseDateAndClearTime)(val));
    } else {
      super();
    }
    this.setHours(0, 0, 0, 0);
  }
}
const DateTimelessToString = date => {
  const day = (0, _numeric.padNumStart)(date.getDate(), 2);
  const month = (0, _numeric.padNumStart)(date.getMonth() + 1, 2);
  const year = (0, _numeric.padNumStart)(date.getYear() + 1900, 4);
  return [year, month, day].join('-');
};
DateTimeless.prototype.toString = function toString() {
  return DateTimelessToString(this);
};
DateTimeless.prototype.toJSON = function toJSON() {
  return DateTimelessToString(this);
};
var _default = DateTimeless;
exports.default = _default;